export default "__VITE_ASSET__DAoOy9kF__"